// extracted by mini-css-extract-plugin
module.exports = {"headerHeight":"72","sellerCardHeight":"92","itemViewerNavPanelHeight":"72"};